export enum TablaTypes {
  AGREGAR_ARCHIVOS = "AGREGAR_ARCHIVOS",
  ELIMINAR_ARCHIVO = "ELIMINAR_ARCHIVO",
  LIMPIAR_ADJUNTOS = "LIMPIAR_ADJUNTOS",
}

export interface ITablaState {
    archivosAdjuntos: File[]
}

interface IAgregarArchivos {
  type: TablaTypes.AGREGAR_ARCHIVOS;
  payload: File[];
}

interface IEliminarArchivo {
  type: TablaTypes.ELIMINAR_ARCHIVO;
  payload: File;
}

interface ILimpiarAdjuntos {
  type: TablaTypes.LIMPIAR_ADJUNTOS;
}

export type TablaActions =
  | IAgregarArchivos
  | IEliminarArchivo
  | ILimpiarAdjuntos;
